import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { useTravels } from '../TravelContext';
import { Trash2 } from 'lucide-react'; 

const MyTravels = () => {
  const { travels, removeTravel } = useTravels();
  const [expandedId, setExpandedId] = useState(null);
  const list = travels;
  
  

  const toggleRow = (id) => setExpandedId((prev) => (prev === id ? null : id));

  return (
    <>
      <div className="h-64 bg-gradient-to-r from-cyan-400 to-blue-500">
        <div
          className="h-full w-full bg-cover bg-center"
          style={{ backgroundImage: "url('https://www.transparenttextures.com/patterns/az-subtle.png')" }}
        />
      </div>

      <div className="font-sans bg-gray-50 dark:bg-gray-900 min-h-[calc(100vh-16rem)] text-gray-900 dark:text-white flex flex-col items-center px-4 sm:px-6 lg:px-8 -mt-32 pb-16">
        <main className="w-full max-w-5xl">
          <section className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-3xl shadow-2xl p-6 sm:p-8 lg:p-10 -translate-y-8">
            <div className="text-center mb-8">
              <h2 className="text-3xl sm:text-4xl font-semibold">Seyahatlerim</h2>
              <p className="text-gray-500 dark:text-blue-200 mt-2 text-md">
                Güncel seyahatlerini buradan görüntüleyebilirsin
              </p>
            </div>

            <ul className="space-y-4">
              {list.map((t) => {
                const isOpen = expandedId === t.id;
                return (
                  <li key={t.id} className="bg-gray-100 dark:bg-slate-700 p-4 rounded-2xl transition-colors">
                    <button
                      onClick={() => toggleRow(t.id)}
                      className="w-full grid grid-cols-2 items-center gap-4 focus:outline-none"
                    >
                      <div className="bg-slate-800/20 dark:bg-white/10 px-4 py-2 rounded-full font-semibold text-left truncate">
                        {t.route}
                      </div>
                      <div className="bg-slate-800/20 dark:bg-white/10 px-4 py-2 rounded-full font-semibold text-right truncate flex items-center justify-end gap-2">
                        {t.nextStop}
                        {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                      </div>
                    </button>

                      {isOpen && (
                        <div className="mt-4 space-y-6 text-sm text-gray-800 dark:text-gray-200">
                          <div className="grid md:grid-cols-3 gap-4">
                            <div className="bg-white dark:bg-slate-800 p-4 rounded-lg">
                              <span className="block text-xs text-gray-500 dark:text-gray-400">Gün Sayısı</span>
                              <span className="font-bold text-lg">{t.details?.days ?? '—'}</span>
                            </div>
                            <div className="bg-white dark:bg-slate-800 p-4 rounded-lg">
                              <span className="block text-xs text-gray-500 dark:text-gray-400">Bütçe</span>
                              <span className="font-bold text-lg">{t.details?.budget ?? '—'}</span>
                            </div>
                            <div className="bg-white dark:bg-slate-800 p-4 rounded-lg md:col-span-1 md:col-start-1 md:row-start-2 md:col-end-4">
                              <span className="block text-xs text-gray-500 dark:text-gray-400">Özet</span>
                              <p className="mt-1 leading-relaxed">{t.details?.planSummary ?? '—'}</p>
                            </div>
                          </div>

                          {t.details && (
                            <div className="space-y-4">
                              {/* Günlük Plan */}
                              {Array.isArray(t.details.gunlukPlan) && t.details.gunlukPlan.length > 0 && (
                                <div className="space-y-4">
                                  <h4 className="text-lg font-bold text-gray-900 dark:text-white">📅 Günlük Plan</h4>
                                  {t.details.gunlukPlan.map((day, di) => (
                                    <div key={di} className="bg-white dark:bg-slate-800 p-4 rounded-lg border-l-4 border-blue-500">
                                      <h5 className="font-semibold text-blue-700 dark:text-blue-400">
                                        {typeof day.gun === 'number' ? `${day.gun}. Gün` : `Gün ${di + 1}`}: {day.baslik || 'Başlıksız'}
                                      </h5>
                                      <p className="mt-2 text-gray-700 dark:text-gray-300 text-sm">
                                        {day.icerik || 'İçerik bilgisi yok'}
                                      </p>
                                    </div>
                                  ))}
                                </div>
                              )}

                              {/* Konaklama Önerileri */}
                              {Array.isArray(t.details.konaklamaOnerileri) && t.details.konaklamaOnerileri.length > 0 && (
                                <div>
                                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-3">🏨 Konaklama Önerileri</h4>
                                  <div className="grid md:grid-cols-2 gap-4">
                                    {t.details.konaklamaOnerileri.map((hotel, hi) => (
                                      <div key={hi} className="bg-white dark:bg-slate-800 p-4 rounded-lg border-l-4 border-green-500">
                                        <p className="font-semibold text-gray-900 dark:text-white">{hotel.isim || 'Otel'}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Tür: {hotel.tip}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Fiyat: {hotel.fiyat}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Adres: {hotel.adres}</p>
                                        {Array.isArray(hotel.ozellikler) && hotel.ozellikler.length > 0 && (
                                          <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
                                            Özellikleri: {hotel.ozellikler.join(', ')}
                                          </p>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {/* Restoran Önerileri */}
                              {Array.isArray(t.details.restoranOnerileri) && t.details.restoranOnerileri.length > 0 && (
                                <div>
                                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-3">🍽️ Restoran Önerileri</h4>
                                  <div className="grid md:grid-cols-2 gap-4">
                                    {t.details.restoranOnerileri.map((resto, ri) => (
                                      <div key={ri} className="bg-white dark:bg-slate-800 p-4 rounded-lg border-l-4 border-orange-500">
                                        <p className="font-semibold text-gray-900 dark:text-white">{resto.isim || 'Restoran'}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Mutfak: {resto.mutfak}</p>
                                        <p className="text-sm text-gray-600 dark:text-gray-400">Fiyat Aralığı: {resto.fiyat_aralik}</p>
                                        {Array.isArray(resto.onerilen) && resto.onerilen.length > 0 && (
                                          <p className="text-xs text-gray-500 dark:text-gray-500 mt-2">
                                            Önerilen: {resto.onerilen.join(', ')}
                                          </p>
                                        )}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              )}

                              {/* Genel Tavsiyeler */}
                              {Array.isArray(t.details.genel_tavsiyeler) && t.details.genel_tavsiyeler.length > 0 && (
                                <div>
                                  <h4 className="text-lg font-bold text-gray-900 dark:text-white mb-3">💡 Genel Tavsiyeler</h4>
                                  <ul className="list-disc list-inside space-y-1 bg-white dark:bg-slate-800 p-4 rounded-lg">
                                    {t.details.genel_tavsiyeler.map((tip, ti) => (
                                      <li key={ti} className="text-gray-700 dark:text-gray-300 text-sm">{tip}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              {/* Silme Butonu */}
                              <button
                                onClick={() => removeTravel(t.id)}
                                className="mt-4 px-4 py-2 text-sm bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors flex items-center gap-2"
                              >
                                <Trash2 size={16} />
                                Sil
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                  </li>
                );
              })}
            </ul>
          </section>
        </main>
      </div>
    </>
  );
};

export default MyTravels;
